/**
 * Intelligence Layer
 *
 * Condition-specific content, test result interpretation,
 * coverage-aware costs, and time-sensitive nudges.
 */

export {
  CONDITION_CONTENT_REGISTRY,
  getConditionContentForStep,
} from "./conditionContent";
export type { ConditionStepContent } from "./conditionContent";

export { useConditionInsights } from "./useConditionInsights";
export type { ConditionInsight } from "./useConditionInsights";

export {
  useTestResultInsights,
  resultInterpretationKey,
} from "./useTestResultInsights";
export type { ResultInterpretation } from "./useTestResultInsights";

export { useCostEstimate } from "./useCostEstimate";
export type { CostEstimate, CostLineItem } from "./useCostEstimate";
